export default {
  'SINGLE_ELEC_RECEIPT': '單筆電子收據',
  'SINGLE_PAPER_RECEIPT': '單筆紙本收據',
  'YEAR_ELEC_RECEIPT': '年度電子收據',
  'YEAR_PAPER_RECEIPT': '年度紙本收據',
};